import { Shark, SmartModel, Utils } from "shark-mvc";
import moment from "moment";

import ConstructionSiteLot from "./ConstructionSiteLot";

class Quotation extends SmartModel {
	static STATUS_PENDING = 1;
	static STATUS_ACCEPTED = 2;
	static STATUS_REFUSED = 3;
	static STATUS_UPLOADED = 4;
	static STATUS_ALL_CSC_CREATED = 5;
	static STATUS_SOME_CSC_CREATED = 6; // Dave. Questo status non DEVE esistere più.
	static STATUS_CS_COMPLETED = 7;
	static STATUS_CS_RUNNING = 11;
	static STATUS_MORE_CSC_THAN_CS = 12;
	static STATUS_SOME_CS_COMPLETED = 10;
	static STATUS_OLD_REVISION = 8;

	siteInfoSheetType = ""; // Join Field

	constructor (data) {
		super();

		this.cca = "";
		this.clientGuid = "";
		this.clientName = "";
		this.code = "";
		this.contact = {}; // Join Object
		this.createdAt = "";
		this.createdByGuid = "";
		this.extraData = {
			confirmData: {
				builtPDFURL: "",
				conditions: "",
				constructionSiteCardGuid: "",//Dave: Devo salvare qui dentro l'informazione
				lotCount: 1,
				pictures: [],
				premisesDestinations: [],
				presumedAmount: 0,
				presumedArea: 0,
				sentFileIsTemporary: false,
				timeSpanAndApplicatorTeam: {
					applicatorTeamId: "",
					extraDates: [],
					timeSpanEnd: "0000-00-00 00:00:00",
					timeSpanStart: "0000-00-00 00:00:00",
				},
				userGuid: ""
			},
			handDelivered: false,
			refuseReason: "",
			relatedGuids: {
				clientGuid: "",
				constructionSiteGuid: "",
				constructionSiteCardGuid: "",
				siteInfoSheetGuid: "",
				visitGuid: "",
			},
			siteLocation: {
				address: "",
				city: "",
				name: "",
				province: "",
				region: "",
				zip: "",
				personInCharge: {
					name: "",
					eMail: "",
					phone: ""
				},
			}
		};
		this.guid = "";
		this.latestFollowUp = "";
		this.lots = [];
		this.newFollowUpCount = 0;
		this.pdfURL = "";
		this.referenceDate = "0000-00-00 00:00:00";
		this.responseDate = "0000-00-00 00:00:00";
		this.revision = 0;
		this.revisionReferenceGuid = "";
		this.sendingDate = "0000-00-00 00:00:00";
		this.siteInfoSheetData = {};
		this.siteInfoSheetGuid = "";
		this.siteInfoSheetRegistry = {}; // Join field
		this.status = 0; //1: pending, 2: accepted, 3: refused, 4: uploaded, 5: ALL CSC Created, 6: Some CSC created 7: CS completed 8: old revision
		this.updatedAt = "0000-00-00 00:00:00";
		this.updatedByGuid = "";
		this.userGuid = "";

		this.__acceptedByCurrUser = false;
		this.__acceptedUserLabel = "";
		this.__agentName = "";
		this.__applicatorTeamName = "";
		this.__ccaCSSClass = "";
		this.__ccaLabel = "";
		this.__enableLotsManagement = false;
		this.__followUpList = [];
		this.__hasNewFollowUp = false;
		this.__hilited = false;
		this.__isLastRevision = false;
		this.__presumedArea = "";
		this.__referenceDate = "0000-00-00 00:00:00";
		this.__referenceDateLabel = "";
		this.__reportData = {};
		this.__revisionLabel = "";
		this.__sendingDate = "0000-00-00 00:00:00";
		this.__sendingDateLabel = "";
		this.__sendingDatePendingDays = 0;
		this.__showAcceptedUser = false;
		this.__showOldCCA = false;
		this.__showPendingWarning = false;
		this.__statusCSSClass = "quotation-status-pending";
		this.__statusLabel = "";
		this.__timeSpanEnd = "";
		this.__timeSpanStart = "";

		if (data) {
			this.import(data);
		}
	}

	//Schfezza, non lo posso usare se non sto accettando il preventivo
	addConstructionSiteLot () {
		this.lots.push(new ConstructionSiteLot());
		this.lots.forEach((item, index) => item.__index = index);
		this.__lotsRemovable = this.lots.length > 1;
	}

	export () {
		const exportData = this.__export();

		const localExtraData = Object.assign({}, this.extraData);
		localExtraData.confirmData.timeSpanAndApplicatorTeam.timeSpanStart = moment.utc(localExtraData.confirmData.timeSpanAndApplicatorTeam.timeSpanStart).format(Shark.get("dateISODateTimeFormat"));
		localExtraData.confirmData.timeSpanAndApplicatorTeam.timeSpanEnd = moment.utc(localExtraData.confirmData.timeSpanAndApplicatorTeam.timeSpanEnd).format(Shark.get("dateISODateTimeFormat"));

		exportData.extraData = JSON.stringify(localExtraData);
		exportData.lots = JSON.stringify(this.lots.map(item => item.export()));
		exportData.referenceDate = moment(this.referenceDate).utc().format(Shark.get("dateISODateTimeFormat"));
		exportData.responseDate = moment(this.responseDate).utc().format(Shark.get("dateISODateTimeFormat"));
		exportData.sendingDate = moment(this.sendingDate).utc().format(Shark.get("dateISODateTimeFormat"));
		exportData.siteInfoSheetData = JSON.stringify(this.siteInfoSheetData);

		return exportData;
	}

	evaluateApplicationTeamLabel () {
		const applicatorTeamList = Shark.get("applicatorTeamList");
		if (applicatorTeamList && applicatorTeamList.length > 0) {
			const currApplicatorTeam = Utils.safp(applicatorTeamList, "guid", this.extraData.confirmData.timeSpanAndApplicatorTeam.applicatorTeamId);

			if (currApplicatorTeam) {
				this.__applicatorTeamName = currApplicatorTeam.name;
			}
		}
	}

	evaluateExtraDates () {
		if (this.extraData.confirmData.timeSpanAndApplicatorTeam.extraDates) {
			this.__extraDates = [];

			this.extraData.confirmData.timeSpanAndApplicatorTeam.extraDates.forEach(item => {
				//Dave: questa cosa è da spostare altrove
				const applicatorTeamList = Shark.get("applicatorTeamList");
				const cloned = Object.assign({}, item);

				if (applicatorTeamList && applicatorTeamList.length > 0) {
					const currApplicatorTeam = Utils.safp(applicatorTeamList, "guid", item.applicatorTeamId);
		
					if (currApplicatorTeam) {
						cloned.__applicatorTeamName = currApplicatorTeam.name;
					}
				}

				if (typeof item.constructionEndDateTime.isValid === "undefined") {
					item.constructionEndDateTime = moment(item.constructionEndDateTime);
					item.constructionStartDateTime = moment(item.constructionStartDateTime);
				}
				
				cloned.__timeSpanEndLabel = item.constructionEndDateTime.format(Shark.get("dateHumanFormat"));
				cloned.__timeSpanStartLabel = item.constructionStartDateTime.format(Shark.get("dateHumanFormat"));
		
				this.__extraDates.push(cloned);
			});

			this.__hasExtraDates = this.__extraDates.length > 1;
		}
	}

	evaluateTimeSpanEndLabel () {
		this.__timeSpanEnd = this.extraData.confirmData.timeSpanAndApplicatorTeam.timeSpanEnd.format(Shark.get("dtIsoDate"));
		this.__timeSpanEndLabel = this.extraData.confirmData.timeSpanAndApplicatorTeam.timeSpanEnd.format(Shark.get("dateHumanFormat"));
	}

	evaluateTimeSpanStartLabel () {
		this.__timeSpanStart = this.extraData.confirmData.timeSpanAndApplicatorTeam.timeSpanStart.format(Shark.get("dtIsoDate"));
		this.__timeSpanStartLabel = this.extraData.confirmData.timeSpanAndApplicatorTeam.timeSpanStart.format(Shark.get("dateHumanFormat"));
	}

	import(data, options) {
		this.__import(data, options);

		this.importField("createdAt", data.createdAt, {dataType: "date"});
		this.importField("revision", data.revision, {dataType: "number"});
		this.importField("status", data.status, {dataType: "number"});

		this.__clientName = this.clientName;

		if (this.importDateField("extraData.confirmData.timeSpanAndApplicatorTeam.timeSpanEnd", this.extraData.confirmData.timeSpanAndApplicatorTeam.timeSpanEnd)) {
			this.evaluateTimeSpanEndLabel();
		}
		if (this.importDateField("extraData.confirmData.timeSpanAndApplicatorTeam.timeSpanStart", this.extraData.confirmData.timeSpanAndApplicatorTeam.timeSpanStart)) {
			this.evaluateTimeSpanStartLabel();
		}

		if (typeof data.latestFollowUp === "string") {
			this.latestFollowUp = data.latestFollowUp;
			this.__hasFollowUp = this.latestFollowUp !== "" || this.__followUpList.length > 0;
		}
		this.newFollowUpCount = parseInt(data.newFollowUpCount);
		this.__hasNewFollowUp = this.newFollowUpCount > 0;

		if (this.extraData.confirmData.presumedAmount !== undefined) {
			const formatterCurrency = new Intl.NumberFormat("it-IT", { currency: "EUR", style: "currency" });
			this.__presumedAmountLabel = formatterCurrency.format(this.extraData.confirmData.presumedAmount);
		}

		if (this.importField("referenceDate", data.referenceDate, {dataType: "date"})) {
			this.referenceDate = moment.utc(this.referenceDate.format("YYYY-MM-DD HH:mm:ss")).local();
			this.__referenceDate = this.referenceDate.format(Shark.get("dateISOFormat"));
			this.__referenceDateLabel = this.referenceDate.format(Shark.get("dateHumanFormat"));
		}
	
		if (this.importField("responseDate", data.responseDate, {dataType: "date"})) {
			this.responseDate = moment.utc(this.responseDate.format("YYYY-MM-DD HH:mm:ss")).local();
			this.__responseDate = this.responseDate.format(Shark.get("dateISOFormat"));
			this.__responseDateLabel = this.responseDate.format(Shark.get("dateHumanFormat"));
		}

		this.importNumberField("revision", data.revision);
		if (this.revision > 0) {
			this.__revisionLabel = ` <small>[rev. ${this.revision}]</small>`;
		}

		if (this.importField("sendingDate", data.sendingDate, {dataType: "date"})) {
			this.sendingDate = moment.utc(this.sendingDate.format("YYYY-MM-DD HH:mm:ss")).local();
			this.__sendingDate = this.sendingDate.format(Shark.get("dateISOFormat"));
			this.__sendingDateLabel = this.sendingDate.format(Shark.get("dateHumanFormat"));

			if (this.status === Quotation.STATUS_PENDING || this.status === Quotation.STATUS_UPLOADED) {
				this.__sendingDatePendingDays = moment().set({hour: 0, minute: 0, seconds: 0}).diff((this.sendingDate ? this.sendingDate : this.referenceDate).clone().set({hour: 0, minute: 0, seconds: 0}), "d");
				this.__showPendingWarning = true;

				if (this.__sendingDatePendingDays < 3) {
					this.__pendingWarningCSSClass = "status-ok";
				}
				else if (this.__sendingDatePendingDays < 7) {
					this.__pendingWarningCSSClass = "status-warning-2";
				}
				else {
					this.__pendingWarningCSSClass = "status-danger-2";
				}
			}
			else {
				this.__showPendingWarning = false;
			}
		}
		
		this.__reportData.quotationStatus = this.status;

		//DAve: ImportField restituisce un boolean, usalo
		if (data.siteInfoSheetData && data.siteInfoSheetData !== "") {
			this.__reportData.province = this.siteInfoSheetData.clientProvince;
			this.__reportData.sector = this.siteInfoSheetData.clientCommoditySector;
			this.__reportData.quotationStatus = this.status;

			this.__systemsLabel = "";
			this.siteInfoSheetData.systems.forEach((premise, premiseIndex) => {
				if (premise.systems) {
					//this.__areasLabel += `${item.area} m<sup>2</sup><br>` ;
					premise.systems.forEach((system, systemIndex) => {
						if (typeof system !== "string") {
							let proposalGroupLabel = "";
						
							if (system.proposalGroup > -1) {
								proposalGroupLabel = system.proposalGroup === 0 ? ` <span class="text-primary icon-thumbs-up"></span>` : ` <span class="text-info">A${system.proposalGroup}</span>`;
								// proposalGroupLabel =  + proposalGroupLabel + "";
							}
	
							//this.__areasLabel += `${item.area} m<sup>2</sup><br>` ;
							this.__systemsLabel += `${system.system}${proposalGroupLabel}<br>`;
							system.__index = premiseIndex * systemIndex;
						}
					}, this);
				}
			}, this);

			this.__reportData.agentGuid = this.userGuid;
			this.__reportData.agentName = this.siteInfoSheetData.agentName;
		}
		
		if (data.siteInfoSheetRegistry && data.siteInfoSheetRegistry !== "") {
			this.__reportData.province = this.siteInfoSheetRegistry.clientProvince;
			this.__reportData.sector = this.siteInfoSheetRegistry.clientCommoditySector;
		}

		if (this.importDateField("updatedAt", data.updatedAt)) {
			this.__updatedAt = this.updatedAt.format("YYYY-MM-DD");
			this.__updatedAtLabel = this.updatedAt.format("DD/MM/YYYY - HH:mm");
			this.__updatedAtDateLabel = this.updatedAt.format("DD/MM/YYYY");
		}
		
		this.__acceptedByCurrUser = this.extraData.confirmData.userGuid !== Shark.get("currUser").guid;
		this.__showAcceptanceStatus = [2, 5, 6, 7].indexOf(this.status) > -1;
		this.__showAcceptedUser = this.__showAcceptanceStatus || [2, 3].indexOf(this.status) > -1;
		this.__siteInfoSheetDate = moment(this.siteInfoSheetData.referenceDate).format(Shark.get("dateHumanFormat"));

		const userList = Shark.get("userList");

		if ([2, 3, 5, 6, 7].indexOf(this.status) > -1) {
			if (userList) {
				const acceptedUser = userList.filter(item => item.guid === this.extraData.confirmData.userGuid);
				if (acceptedUser.length > 0) {
					this.__acceptedUserLabel = acceptedUser[0].__fullName;
				}
			}
		}


		if (this.siteInfoSheetData) {
			const sisAgent = userList.filter(item => item.guid === this.siteInfoSheetData.agentGuid);
			if (sisAgent.length > 0) {
				this.__agentName = sisAgent[0].__fullName;
			}
		}

		this.evaluateApplicationTeamLabel();
		this.evaluateExtraDates();
		this.parseCCA(); // A tendere deve sparire le CCA sono nei lotti
		this.parseStatus();
		this.parseTemporaryConfirmFile();
		this.parseLots();
		this.parseRegistry();
		this.parseSISArea();
	}

	on__enableLotsManagementChanged () {
		if (this.lots.length > 1) {
			if (confirm("Sei sicuro di voler passare ad un singolo lotto?\nLe informazioni inserite sui lotti aggiuntivi verranno perse.")) {
				this.lots.length = 1;
				this.__showMutliSystemAndMultiLotWarning = false;
				Shark.render();
			}
		}
		else {
			this.__showMutliSystemAndMultiLotWarning = Shark.get("__showProposalGroups") && this.__enableLotsManagement;
			Shark.render();
		}
	}

	onCcaChanged () {
		this.cca = this.cca.trim();
	}

	onDataChanged(data) {
		switch (data.property) {
			case "extraData.confirmData.presumedAmount": {
				const formatterCurrency = new Intl.NumberFormat("it-IT", { currency: "EUR", style: "currency" });
				this.__presumedAmountLabel = formatterCurrency.format(this.extraData.confirmData.presumedAmount);
				break;
			}
			case "extraData.confirmData.timeSpanAndApplicatorTeam.applicatorTeamId":
				this.evaluateApplicationTeamLabel();
				break;
			case "extraData.confirmData.timeSpanAndApplicatorTeam.extraDates":
				this.evaluateExtraDates();
				break;
			case "__followUpList":
				this.__hasFollowUp = this.__followUpList.length > 0;
				break;
			case "__referenceDate":
			case "__sendingDate": {
				let mainPropName = data.property.substr(2);

				this[mainPropName] = moment(this[data.property]);
				this[`__${mainPropName}Label`] = this[mainPropName].format(Shark.get("dateHumanFormat"));
				break;
			}
			case "__timeSpanEnd":
			case "__timeSpanStart": {
				let mainPropName = data.property.substr(2);
				this.extraData.confirmData.timeSpanAndApplicatorTeam[mainPropName] = moment(this[data.property]);
				this.evaluateTimeSpanEndLabel();
				this.evaluateTimeSpanStartLabel();
				break;
			}
		}
	}

	onExtraData_confirmData_sentFileIsTemporaryChanged () {
		this.parseTemporaryConfirmFile();
	}

	parseCCA () {
		if ([2, 5, 7].indexOf(this.status) > -1) {
			if (this.cca && this.cca !== "") {
				//DAve: schifo
				this.__ccaLabel = "<strong><span data-search-field=\"cca\">" + this.cca + "<span></strong>";
				this.__ccaCSSClass = "cca-status-success";
			}
			else {
				this.__ccaLabel = "<span class=\"text-muted\">Non impostata</span>";
				this.__ccaCSSClass = "cca-status-warning";
			}
		}
	}

	parseLots () {
		if (this.lots && this.lots.length > 0) {
			this.lots = this.lots.map(item => new ConstructionSiteLot(item));
		}
		else {
			this.lots = [new ConstructionSiteLot()];
			this.__showOldCCA = this.cca !== "";
		}

		this.lots.forEach((item, index) => {
			item.__index = index;
			item.__displayIndex = index + 1;
		});
		this.__lotsCSCCreated = this.lots.reduce((counter, lot) => counter + (lot.status === 2), 0);
		this.__showLotsBadge = this.lots.length > 1;
	}

	parseRegistry () {
		//Dave.ToDo: visto che questa cosa del registry c'è in tanti posti, presumo dovrebbe diventare un oggetto
		//  Diciamo una roba legata al "Progetto" (anche se ancora non esiste), che abbia un solo punto di salvataggio e gli altri lo leggono e basta
		if (this.siteInfoSheetRegistry) {
			const registry = this.siteInfoSheetRegistry;

			this.__receiverIsCustomer = registry.receiver === "customer";
			this.__receiverIsDesigner = registry.receiver === "designer";
			this.__receiverIsEndUser = registry.receiver === "endUser";
			
			// Dave: Questa roba del "_[role]Name" è tutta da uniformare e gestire.
			this.__customerName = registry.customerName;
			this.__designerName = registry.designerName;
			this.__endUserName = registry.endUserName;

			if (this.__customerName === "" && this.customer) {
				this.__customerName = this.customer.name;
			}
	
			if (this.__designerName === "" && this.designer) {
				this.__designerName = this.designer.name;
			}
	
			if (this.__endUserName === "" && this.endUser) {
				this.__endUserName = this.endUser.name;
			}
	
			switch (registry.receiver) {
				case "customer":
					this.__receiverNameLabel = registry.customerName || this.__customerName || registry.clientName;
					this.__receiverTypeLabel = "Committente";
					break;
				case "designer":
					this.__receiverNameLabel = registry.designerName || this.__designerName || registry.clientName;
					this.__receiverTypeLabel = "Progettista";
					break;
				case "endUser":
					this.__receiverNameLabel = registry.endUserName || this.__endUserName || registry.clientName;
					this.__receiverTypeLabel = "Utilizzatore Finale";
					break;
			}
	
			//Se c'è un committente è lui che va mostrato, se no si passa al progettista, se no all'utente finale (in teoria impossibile)
			if (this?.__customerName?.trim() !== "") {
				this.__receiverNameLabel = this.__customerName;
				this.__receiverCSSClass = "customer";
				this.__receiverTypeLabel = "Committente";
			}
			else if (this?.__designerName?.trim() !== "") {
				this.__receiverNameLabel = this.__designerName;
				this.__receiverCSSClass = "designer";
				this.__receiverTypeLabel = "Progettista";
			}
			else if (this?.__endUserName?.trim() !== "") {
				this.__receiverNameLabel = this.__endUserName;
				this.__receiverCSSClass = "endUser";
				this.__receiverTypeLabel = "Utilizzatore finale";
			}

			this.__clientName = this.__receiverNameLabel;
		}
	}

	parseSISArea () {
		if (this?.siteInfoSheetData?.systems && this.siteInfoSheetData.systems.length > 0) {
			this.__mq = this.siteInfoSheetData.systems.reduce((total, interventionArea) => {
				return total + interventionArea.systems.reduce((sum, system) => {
					// console.log({sum, total, interventionArea, system});
					return sum + system.area;
				}, 0);
			}, 0);
		}
	}

	parseStatus () {
		switch (this.status) {
			case 1:
				this.__statusCSSClass = "quotation-status-pending";
				break;
			case 2:
				this.__statusCSSClass = "quotation-status-accepted quotation-status-accepted-waiting-csc";
				break;
			case 3:
				this.__statusCSSClass = "quotation-status-refused";
				break;
			case 4:
				this.__statusCSSClass = "quotation-status-uploaded";
				break;
			case 5:
				this.__statusCSSClass = "quotation-status-accepted quotation-status-accepted-csc-created";
				break;
			case 6:
				this.__statusCSSClass = "quotation-status-accepted quotation-status-accepted-csc-created";
				break;
			case 7:
				this.__statusCSSClass = "quotation-status-accepted quotation-status-accepted-cs-ended";
				break;
		}

		const quotationStatusMap = Shark.get("quotationStatusMap");
		this.__statusLabel = quotationStatusMap[this.status];
		this.__reportData.status = this.status;

		this.__status_pending = this.status === Quotation.STATUS_PENDING;
		this.__status_accepted = this.status === Quotation.STATUS_ACCEPTED;
		this.__status_refused = this.status === Quotation.STATUS_REFUSED;
		this.__status_uploaded = this.status === Quotation.STATUS_UPLOADED;
		this.__status_cscCreated = [Quotation.STATUS_SOME_CSC_CREATED, Quotation.STATUS_ALL_CSC_CREATED].indexOf(this.status) > -1;
	}

	parseTemporaryConfirmFile() {
		if (this.extraData.confirmData.sentFileIsTemporary) {
			this.__temporaryConfirmFileCSSClass = "quotation-confirm-is-temporary";
		}
		else {
			this.__temporaryConfirmFileCSSClass = "";
		}
	}
	removeConstructionSiteLot (index) {
		this.lots.splice(index, 1);
		this.lots.forEach((item, index) => item.__index = index);
		this.__lotsRemovable = this.lots.length > 1;
		Shark.render();
		console.log(this);
	}

	resetStatusToPending () {
		this.extraData.confirmData = {
			builtPDFURL: "",
			conditions: "",
			constructionSiteCardGuid: "",
			lotCount: 1,
			pictures: [],
			premisesDestinations: [],
			presumedAmount: 0,
			presumedArea: 0,
			timeSpanAndApplicatorTeam: {
				applicatorTeamId: "",
				extraDates: [],
				timeSpanEnd: "0000-00-00 00:00:00",
				timeSpanStart: "0000-00-00 00:00:00",
			},
			userGuid: ""
		};
		this.lots = [];
		this.responseDate = "0000-00-00 00:00:00";
		this.status = Quotation.STATUS_PENDING;

		this.parseStatus();
		this.parseLots();
	}
}

Shark.registerModel("Quotation", Quotation);

export default Quotation;